import React, { Component } from 'react';
import HeaderLocation from '../components/Header';

class ComidasIngredientes extends Component {
  render() {
    return (
      <div>
        <HeaderLocation />
      </div>
    );
  }
}

export default ComidasIngredientes;
